import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Sidebar } from 'semantic-ui-react';
import { GO_LOGIN } from '../../../../../store/actions/auth.types';
import SidebarContainer from './SidebarContainer';
import MobileHeader from '../../../../components/Header/MobileHeader/MobileHeader';
import MobileQuickLinks from '../../../../components/Header/MobileHeader/MobileQuickLinks';
import MobileRealTalk from '../../../../components/Footer/MobileFooter/MobileRealTalk';
import MobileFooter from '../../../../components/Footer/MobileFooter/MobileFooter';
import DesktopFooter from '../../../../components/Footer/DesktopFooter/DesktopFooter';
import DesktopRealTalk from '../../../../components/Footer/DesktopFooter/DesktopRealTalk';
import { toggleSidebar } from '../../../../../store/actions/sidebar.actions';
import { sidebarVisible } from '../../../../../store/reducers/sidebar.selectors';
import * as browserTypes from '../../../../../store/actions/browser.types';

class SidebarMenu extends PureComponent {
  render() {
    // const { visible } = this.state;
    const { visible, toggleMenu, children, isLoggedIn, mediaType, loginView, isPrintPage } = this.props;

    return (
      <Sidebar.Pushable>
        {!isPrintPage && <SidebarContainer visible={visible} toggleVisibility={toggleMenu} />}
        <Sidebar.Pusher style={{ backgroundColor: '#ffffff' }}>
          {!isPrintPage &&<MobileHeader toggleVisibility={toggleMenu} />}
          {!isPrintPage && <MobileQuickLinks />}
          {children}
          {isPrintPage ? null : mediaType === browserTypes.MOBILE
          ? <fØ>
            {!isLoggedIn && !loginView && <MobileRealTalk />}
            <MobileFooter />
          </fØ>
          : <fØ>
            {!isLoggedIn && !loginView && <DesktopRealTalk />}
            <DesktopFooter />
          </fØ>
          }
        </Sidebar.Pusher>
      </Sidebar.Pushable>
    );
  }
}

SidebarMenu.propTypes = {
  visible: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  mediaType: PropTypes.string.isRequired,
  loginView: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  visible: sidebarVisible(state),
  mediaType: state.browser.mediaType,
  loginView: state.location.type === GO_LOGIN,
});

const mapDispatchToProps = dispatch => ({
  toggleMenu: ({ visible }) => dispatch(toggleSidebar({ visible })),
});

export default connect(mapStateToProps, mapDispatchToProps)(SidebarMenu);



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/SidebarMenu.js